import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { CollapseMenu } from '../../../common/CollapseMenu/CollapseMenu';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import stores from 'cd-eft/models/Stores';
import './ElementContainer.scss';

interface IElementContainerProps {
  element: string;
  store: string;
  children: any;
}

const designStore = stores.AppStore.designStore;

const ElementContainerComponent = (props: IElementContainerProps) => {
  const elementTitle = useRef(props.element).current;
  const currentElement = elementTitle.toLowerCase();
  const currentStore = useRef(stores.AppStore[props.store]).current;

  return (
    <>
      {/* loader */}
      {currentStore.isLoading && !designStore.isLoading && <Loader />}

      <CollapseMenu
        showAsHeader={true}
        title={`${elementTitle} Design`}
        cardBodyId={`${currentElement}-designelement-container`}
        noIcon={true}
        forceOpen={true}
        className="designelement-container"
        titleClass="capitalize"
      >
        {/* tabs */}

        <div className="rcn-top-nav">
          <ul>
            <li className="table-name">
              <a
                data-testid={`${currentElement}-summary-link`}
                className={currentStore.currentTab === `Summary` ? 'active' : ''}
                onClick={() => {
                  currentStore.currentTab = `Summary`;
                }}
              >
                <strong className="capitalize">Summary</strong>
              </a>
            </li>

            {currentStore.currentTab !== 'Edit' && !currentStore.currentElement.id && (
              <li className="table-name capitalize" data-testid={`new-${currentElement}-tab`}>
                <a
                  data-testid={`new-${currentElement}-link`}
                  className={currentStore.currentTab === `New` ? 'active' : ''}
                  onClick={() => (currentStore.currentTab = `New`)}
                >
                  <strong>{currentStore.currentElement.name}</strong>
                </a>
              </li>
            )}

            {currentStore.currentTab !== 'New' && currentStore.currentElement.id && (
              <li className="table-name" data-testid={`edit-${currentElement}-tab`}>
                <a
                  data-testid={`edit-${currentElement}-link`}
                  className={currentStore.currentTab === `Edit` ? 'active' : ''}
                  onClick={() => (currentStore.currentTab = `Edit`)}
                >
                  <strong>{currentStore.currentElement.name}</strong>
                </a>
              </li>
            )}
          </ul>
        </div>

        {/* constent */}
        {props.children}
      </CollapseMenu>
    </>
  );
};

export const ElementContainer = observer(ElementContainerComponent);
